import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import client, { fileUrl } from "../lib/api";
import { Crest, Loading, Card, Pill, Zig } from "../components/common";
import { MATCH_ACTION } from "../lib/clubMedia";

const ACTION = MATCH_ACTION;

function Stat({ label, value }) {
  return <div className="text-center"><div className="font-head font-black text-2xl text-green tabular">{value}</div><div className="text-[11px] uppercase tracking-wider text-ink/50">{label}</div></div>;
}

export default function PlayerPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); client.get(`/players/${id}`).then((r) => setData(r.data)).catch(() => setData(false)); }, [id]);
  if (data === null) return <Loading />;
  if (!data) return <div className="py-20 text-center">Player not found.</div>;
  const { player: p, club } = data;
  return (
    <div data-testid="player-page" className="max-w-3xl mx-auto">
      <Card className="overflow-hidden">
        <div className="relative h-48 bg-green grain">
          <img src={p.photo ? fileUrl(p.photo) : ACTION} alt={`${p.name} of ${club?.name}`} className="absolute inset-0 w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-t from-green to-transparent" />
          <div className="absolute bottom-4 left-6 text-cream flex items-end gap-4">
            <span className="font-head font-black text-6xl text-gold tabular leading-none">{p.shirt}</span>
            <div>
              <h1 className="font-head font-black text-3xl tracking-tight">{p.name}</h1>
              <Link to={`/clubs/${club?.slug}`} className="flex items-center gap-2 mt-1 text-cream/80 hover:text-gold"><Crest slug={club?.slug} name={club?.name} size={22} url={club?.badge} />{club?.name}</Link>
            </div>
          </div>
          <div className="absolute top-4 right-4"><Pill tone="gold">{p.position}</Pill></div>
        </div>
        <div className="p-6">
          <div className="flex items-center justify-between bg-cream rounded-sm p-4 mb-6">
            <div>
              <div className="text-xs uppercase tracking-widest text-ink/50 font-bold">Fantasy value</div>
              <Zig value={p.zig_price} className="font-head font-black text-3xl text-green" />
            </div>
            <div className="text-right">
              <div className="text-xs uppercase tracking-widest text-ink/50 font-bold">Total points</div>
              <div className="font-head font-black text-3xl text-gold tabular">{p.points}</div>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-3">
            <Stat label="Goals" value={p.goals} />
            <Stat label="Assists" value={p.assists} />
            <Stat label="Minutes" value={p.minutes} />
            <Stat label="Clean sheets" value={p.clean_sheets} />
          </div>
        </div>
      </Card>
      <p className="text-xs text-ink/40 mt-3 text-center">All values priced in ZiG (ZWG). Fantasy weighting applied uniformly across all clubs.</p>
    </div>
  );
}
